import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from '@tanstack/react-query';
import { UpdateTopicRequest, } from '@wit-support/admin-contracts';
import { Dialog, DialogContent, DialogDescription, DialogTitle, toast } from '@wit-support/ui';
import { Actions, SubmitButton, ZodField, ZodForm, CancelButton } from '@wit-support/ui-forms';
import { updateTopic } from '../api.js';
export function EditTopicDialog({ topic, onClose, onSaved }) {
    const mut = useMutation({
        mutationFn: (body) => updateTopic(topic.id, body),
        onSuccess: () => {
            toast.success('Тема обновлена');
            onSaved();
        },
        onError: (err) => toast.error(err.message),
    });
    return (_jsx(Dialog, { open: true, onOpenChange: (v) => (!v ? onClose() : null), children: _jsxs(DialogContent, { children: [_jsx(DialogTitle, { children: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0442\u0435\u043C\u0443" }), _jsxs(DialogDescription, { children: ["\u041A\u043B\u044E\u0447 \u0442\u0435\u043C\u044B ", _jsx("strong", { className: "font-mono", children: topic.key }), " \u043D\u0435\u043B\u044C\u0437\u044F \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C."] }), _jsxs(ZodForm, { schema: UpdateTopicRequest, defaultValues: {
                        name: topic.name,
                        description: topic.description,
                        sortOrder: topic.sortOrder,
                    }, onSubmit: (values) => {
                        const v = values;
                        const payload = {};
                        if (v.name !== undefined && v.name !== topic.name)
                            payload.name = v.name;
                        if (v.description !== undefined && v.description !== topic.description)
                            payload.description = v.description;
                        if (v.sortOrder !== undefined && v.sortOrder !== topic.sortOrder)
                            payload.sortOrder = v.sortOrder;
                        if (Object.keys(payload).length === 0) {
                            onClose();
                            return;
                        }
                        mut.mutate(payload);
                    }, children: [_jsx(ZodField, { name: "name" }), _jsx(ZodField, { name: "description" }), _jsx(ZodField, { name: "sortOrder" }), _jsxs(Actions, { children: [_jsx(CancelButton, { onClick: onClose }), _jsx(SubmitButton, { pendingLabel: "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435\u2026", children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" })] })] })] }) }));
}
//# sourceMappingURL=edit-dialog.js.map